<template>
  <v-row>
    <v-col cols="12" md="4" align="stretch" height="auto">
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>
          RPC Resolución en el Primer Contacto (FCR)
        </v-card-title>

        <v-row align="stretch">
          <v-col cols="12">
            <v-simple-table light dense>
              <template v-slot:default>
                <thead>
                  <tr style="background-color: #3fa9be; color: white;">
                    <th
                      class="text-center"
                      style="width: 50%;color: white !important;"
                    >
                      Dato
                    </th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-center"
                          v-on="on"
                          style="color: white !important;"
                        >
                          Cantidad
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá la cantidad de tickets/casos
                        <br />de cada tipo indicado para el período.
                      </span>
                    </v-tooltip>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.titulo }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(index, 1)"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c1'"
                        @click="mostrarInput(index, 1)"
                        style="width: 100%"
                        >{{ item.cantidad | numero }}</span
                      >
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 'f' + index + 'c1'"
                        :ref="'f' + index + 'c1'"
                        v-model="datos[index].cantidad"
                        @keydown.tab.stop.prevent="finEdicionDown(index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(index, 1)
                        "
                        @keyup.esc="escape('f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col align-self="center">
            <v-card>
              <p class="text-center display-1" style="width: 100%;">
                RPC: {{ (calculaRpc().toFixed(2) + '').replace('.', ',') }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0 caption"
        align="stretch"
        height="auto"
      >
        Si querés saber más sobre lo que hacemos en BleCX y cómo podemos
        ayudarte con tu negocio o empresa contactate con nosotros
        <a
          href="http://www.blecx.com.ar/#contacto"
          target="_blank"
          rel="noopener noreferrer"
          aria-current="page"
          >aquí</a
        >
      </v-card>
    </v-col>

    <v-col cols="12" md="8">
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline">¿Qué es RPC?</v-card-title>
        <v-card-subtitle class="text-justify"
          >La Tasa de Resolución del Primer Contacto (FCR: First Contact
          Resolution Rate) indica la frecuencia con la que se cierran los casos
          de atención al cliente en su primer intento. Si un caso no se resuelve
          rápidamente, o si un cliente necesita revisar el problema, podría
          tener un impacto negativo en su satisfacción, por lo que llevar este
          número lo más cercano al 100% debería ser una
          prioridad.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline"
          >¿Cómo se obtienen los datos?</v-card-title
        >
        <v-card-subtitle class="text-justify"
          >Elegí la cantidad de tickets/incidentes de un período específico de
          tiempo (un año, un mes, todo el tiempo, etc.) y sé consistente al
          ingresar las métricas desde ese momento para mayor
          precisión.</v-card-subtitle
        >
        <v-card-text>
          <a
            href="https://www.blecx.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-img
              src="../assets/logo.svg"
              width="80"
              align="bottom"
              class="ml-auto"
            ></v-img>
          </a>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      celda_activa: '',
      datos: [
        {
          titulo: 'Total de tickets/casos cerrados, incluídos los reabiertos',
          cantidad: null,
        },
        { titulo: 'Total de tickets/casos reabiertos', cantidad: null },
        {
          titulo:
            'Incidentes totales, incluidos resueltos, reabiertos y no resueltos',
          cantidad: null,
        },
      ],
    };
  },
  filters: {
    numero: function(value) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return value;
    },
    porcentaje(val) {
      return ((val * 100).toFixed(2) + '%').replace('.', ',');
    },
  },

  methods: {
    calculaRpc() {
      var valor =
        (parseInt(this.datos[0].cantidad) - parseInt(this.datos[1].cantidad)) /
        parseInt(this.datos[2].cantidad);
      if (!isFinite(valor) || (!valor && valor !== 0)) return 0;
      return valor;
    },
    mostrarInput(fila, columna) {
      var referencia = `f${fila}c${columna}`;
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    finEdicionUp(fila, columna) {
      var prox_fila = fila > 0 ? fila - 1 : 0;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicionDown(fila, columna) {
      var prox_fila = fila < 2 ? fila + 1 : 2;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicion(referencia) {
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    escape(referencia) {
      this.celda_activa = '';
      this.$nextTick(() => {
        this.$refs[referencia][0].blur();
      });
    },
    esNumero(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
.activa {
  background-color: #eaf0f6;
}
.campo {
  width: 100%;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
} /* solución a los títulos de vcard que se cortan las palabras a la mitad */
</style>
